(() => {
  const ELEMENT_NAME = "dynamic-drawer";

  const attributes = {
    type: "drawer-type",
    title: `data-${ELEMENT_NAME}-title`,
    content: `data-${ELEMENT_NAME}-content`,
    body: `data-${ELEMENT_NAME}-body`,
    close: `data-${ELEMENT_NAME}-close`,
  };

  class DynamicDrawer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this._initElements();
      this._initEvents()
    }

    _initElements() {
      this.$content = this.querySelector(`[${attributes.content}]`);
      this.$title = this.querySelector(`[${attributes.title}]`);
      this.$body = this.querySelector(`[${attributes.body}]`);
      this.$closeBtns = this.querySelectorAll(`[${attributes.close}]`);
    }

    _initEvents() {
      this.$closeBtns.forEach(($btn) =>
        $btn.addEventListener("click", () => this.hide())
      );

      document.addEventListener("product:added", this.hide.bind(this))
    }

    fillAndShow({title, body, type}) {
      this.setAttribute(attributes.type, type)

      this.$title.innerHTML = title;
      this.$body.innerHTML = body;

      this.show()
    }

    show() {
      this.classList.add("show");
      document.body.classList.add("overflow-hidden")
    }

    hide() {
      this.classList.remove("show");
      document.body.classList.remove("overflow-hidden")
    }
  }

  customElements.define(ELEMENT_NAME, DynamicDrawer);
})();
